export const PLAN_CREATED_SUCCESS_MESSAGE = "Plan created!";
export const PLAN_CREATED_FAILURE_MESSAGE = "Failed to delete plan";

export const PLAN_UPDATED_SUCCESS_MESSAGE = "Plan name updated!";
export const PLAN_UPDATED_FAILURE_MESSAGE = "Failed to delete plan";

export const PLAN_DELETED_SUCCESS_MESSAGE = "Plan deleted!";
export const PLAN_DELETED_FAILURE_MESSAGE = "Failed to delete plan";
